import { Form, Button, Card, FloatingLabel, InputGroup } from "react-bootstrap";
import { LoginCode } from "./Login.Code";
import styles from "./styles.module.css";
import { ButtonSpinner } from "../../../componentes";
import { AutenticacaoModule } from "src/Contexto/auth";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

export function LoginView() {
  const code = LoginCode();
  const { isLogged } = AutenticacaoModule();
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div>
      {!isLogged && (
        <div
          className={`d-flex justify-content-center align-items-center ${styles.painel}`}
        >
          <Card className="col-11 col-sm-6 col-md-5 col-lg-4 col-3">
            <Card.Header>Logar no sistema</Card.Header>
            <Card.Body>
              <Form noValidate onSubmit={code.handleSubmit(code.onSubmit)}>
                <InputGroup hasValidation>
                  <FloatingLabel className="mb-3" label="Email">
                    <Form.Control
                      type="email"
                      placeholder="Digite seu email"
                      className={code.errors.email ? "is-invalid" : ""}
                      {...code.register("email")}
                    ></Form.Control>
                    {code.errors.email && (
                      <Form.Control.Feedback type="invalid">
                        {code.errors.email.message?.toString()}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </InputGroup>
                <InputGroup hasValidation>
                  <FloatingLabel className="mb-3" label="Senha">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Digite sua senha"
                      className={code.errors.senha ? "is-invalid" : ""}
                      {...code.register("senha")}
                    ></Form.Control>
                    <span
                      onClick={() => setShowPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        right: 15,
                        top: 20,
                        zIndex: 2,
                        cursor: "pointer",
                        color: "#6c757d",
                      }}
                      tabIndex={-1}
                    >
                      <FontAwesomeIcon
                        icon={showPassword ? faEyeSlash : faEye}
                      />
                    </span>
                    {code.errors.senha && (
                      <Form.Control.Feedback type="invalid">
                        {code.errors.senha.message?.toString()}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </InputGroup>
                <Form.Group className="mb-3" controlId="">
                  <Form.Check type="checkbox" id="lembrar">
                    <Form.Check.Input
                      type="checkbox"
                      {...code.register("lembrar")}
                    ></Form.Check.Input>
                    <Form.Check.Label>Lembrar</Form.Check.Label>
                  </Form.Check>
                </Form.Group>
                <div className="d-grid gap-2">
                  <ButtonSpinner
                    variant="primary"
                    type="submit"
                    loading={code.loading}
                    data-bs-theme="light"
                  >
                    Acessar
                  </ButtonSpinner>
                </div>
                <Button
                  variant="link"
                  onClick={code.onClickNavigate("/cadastro")}
                  className="ps-0"
                >
                  Cadastre-se
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </div>
      )}
    </div>
  );
}

export default LoginView;
